import PanelContainer from "../../lib/panel/panel-container";
import { FloatingPanelSeparator } from "@babackapp/ui/components/floating-panel";
import { RowBlockProps } from "./types";
import { EmailPanelLayout } from "./email-panel-layout";
import { EmailPanelSubBlocks } from "./email-panel-sub-blocks";
import PanelRowVerticalAlignment from "./email-panel-vertical-alignment";
import PanelRowStackOnMobile from "./email-panel-stack-on-mobile";


export function ButtonEmailPanelRenderer(blockProps: RowBlockProps) {
	return (
		<PanelContainer blockProps={blockProps}>
			<EmailPanelLayout />
			<FloatingPanelSeparator />
			<PanelRowVerticalAlignment />
			<FloatingPanelSeparator />
			<PanelRowStackOnMobile />
			<FloatingPanelSeparator />
			<EmailPanelSubBlocks/>
		</PanelContainer>
	);
}
